import { useContext } from "react";
import { SubscriptionContext } from "../SubscriptionContext";

export function useFeatures() {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) {
    throw new Error(
      "useFeatures doit être utilisé dans un SubscriptionProvider"
    );
  }
  return {
    features: ctx.enabledFeatures,
    hasFeature: ctx.hasFeature,
    isLoading: ctx.isLoading,
  };
}
